export const getDocId = (d) => {
    if (!d) return null;
    const raw = d.id;
    if (raw === null || raw === undefined || raw === '') return null;
    const num = Number(raw);
    return Number.isFinite(num) && num > 0 ? num : null;
};

export const getFileKey = (document) => document?.fileKey ?? null;

export const getDocumentFileName = (document) => document?.fileName ?? 'File';

export const getCommentId = (comment) => comment?.id ?? null;

export const getCreatedCommentId = (response) => response?.data?.commentId ?? null;

export const normalizeDocumentList = (raw, dialogVisible, requestId) => {
    const list = Array.isArray(raw) ? raw : raw?.data ?? raw?.items ?? raw?.Data ?? [];
    return dialogVisible && requestId ? list : [];
};

export const normalizeDocumentGroups = (raw, dialogVisible, requestId) => {
    if (!dialogVisible || !requestId) {
        return { dealerCustomerFiles: [], technicalTeamFiles: [] };
    }

    const { dealerCustomerFiles = [], technicalTeamFiles = [] } = raw?.data || {};

    return { dealerCustomerFiles, technicalTeamFiles };
};
